import { css } from '@emotion/css';

const wrapper = css`
  display: flex;
  flex-direction: column;
  gap: var(--spacings-4);
`;

const content = css`
  padding: 0 var(--dimensions-15);
  display: flex;
  flex-direction: column;
  gap: var(--spacings-4);

  .MuiInputBase-root {
    width: fit-content;
  }

  @media (max-width: 728px) {
    padding: 0;
  }
`;

const actionsContainer = css`
  display: flex;
  gap: var(--spacings-3);
  justify-content: center;
  align-items: center;

  button {
    width: 100%;
  }

  @media (max-width: 728px) {
    flex-direction: column-reverse;
  }
`;

const createNewAccountStyles = {
  wrapper,
  content,
  actionsContainer,
};

export default createNewAccountStyles;
